import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';

//Extra components
import { LoadingModal } from 'lib.front';
import MUIDataTable from "mui-datatables";
//GraphQL
import { useLazyQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

//DS
import { ticketPrioridad, ticketEstado } from '../../../common/libreria';

const filtroEstado = [ticketEstado(0), ticketEstado(1), ticketEstado(2)];
const filtroEstadoOptions = [ticketEstado(0), ticketEstado(1), ticketEstado(2), ticketEstado(3)];
const filtroPrioridadOptions = [
   ticketPrioridad(0),
   ticketPrioridad(1),
   ticketPrioridad(2),
   ticketPrioridad(3)
];

const queryRecuperar = gql`
   query TicketsFiltro($cliente: String!) {
      ticketsFiltro(cliente: $cliente) {
         codigo
         asunto
         fecha
         prioridad
         estado
      }
   }
`;

function ListaTicket({ usuario }) {
   const clienteS = usuario.codigo;

   //estados
   const [logged, setLogged] = useState(false);

   const history = useHistory();

   function ButtonClick(ticketCod) {
      return (
         <button
            type="button"
            onClick={() => {
               history.push(`/verTicket/${ticketCod}`);
            }}
         >
            Ver Detalle
         </button>
      );
   }

   //columnas de la tabla
   const column = [
      {
         name: 'codigo',
         label: 'Ticket',
         options: {
            filter: true,
            display: true
         }
      },
      {
         //name: "cliente.denominacion",
         name: 'asunto',
         label: 'Asunto',
         options: {
            filter: true,
            display: true
         }
      },
      {
         name: 'fecha',
         label: 'Fecha Registro',
         options: {
            filter: true,
            display: true,
            customBodyRender: (value, tableMeta, updateValue) => {
               return new Date(value).toDateString();
               //return  new Date(value).toLocaleString();
            }
         }
      },
      {
         name: 'prioridad',
         label: 'Prioridad',
         options: {
            filter: true,
            display: true,
            customBodyRender: (value, tableMeta, updateValue) => {
               return ticketPrioridad(value);
            },
            filterOptions: {
               names: filtroPrioridadOptions
            }
         }
      },
      {
         name: 'estado',
         label: 'Estado Atención',
         options: {
            filter: true,
            display: true,
            customBodyRender: (value, tableMeta, updateValue) => {
               return ticketEstado(value);
            },
            filterList: filtroEstado,
            customFilterListOptions: { render: v => `Estado: ${v}` },
            filterOptions: {
               names: filtroEstadoOptions
            }
         }
      },
      {
         name: 'Detalle',
         options: {
            filter: false,
            sort: false,
            empty: true,
            customBodyRender: (value, tableMeta, updateValue) => {
               return ButtonClick(tableMeta.rowData[0]);
               /*<button onClick={() => {
              //[tableMeta.rowIndex];
              //window.alert(tableMeta.rowData[0]);
              
                if (tableMeta !== null && tableMeta !== undefined){
                    setTicketCodigo(tableMeta.rowData[0]);
                    setMostrar(true);
                }
                else{
                    setTicketCodigo(null);
                    setMostrar(false);
                }
                
              }
            }>
            Ver Detalle
          </button>*/
            }
         }
      }
   ];

   const [recuperar, { called, loading, data }] = useLazyQuery(queryRecuperar, {
      variables: { cliente: clienteS }
   });
   /*
  const onRowClick = (rowData) => {
        if (rowData !== null && rowData !== undefined && mostrar === false){
           setTicketCodigo(rowData[0]);
           setMostrar(true);
        }
        else{
            setTicketCodigo(null);
            setMostrar(false);
        }
    }
    */
   const options = {
      filterType: 'dropdown',
      selectableRows: 'none',
      responsive: 'scrollFullHeight',
      //onRowClick: onRowClick,
      setRowProps: rowAux => ({
         onDoubleClick: () => {
            //onRowClick(rowAux);
         }
      }),
      textLabels: {
         body: {
            noMatch: 'Ningún caso registrado'
         }
      },
      rowsPerPage: 20,
      page: 1
   };

   useEffect(() => {
      if (data !== undefined) {
         console.log(new Date(data.ticketsFiltro));
      }
   }, [data]);

   useEffect(() => {
      setLogged(usuario !== undefined && usuario !== null);
   }, [usuario]);

   if (called && loading)
      return (
         <div style={{ width: '100%', height: '100%' }}>
            <LoadingModal open={loading} noFullScreen containerId="MainContainer" />
         </div>
      );
   if (!called) {
      return <>{recuperar()}</>;
   }

   function verListaTicket() {
      return (
         <div className="tickets">
            <MUIDataTable
               title={<Typography variant="h2" gutterBottom>
                  Mis Tickets
               </Typography>}
               data={data.ticketsFiltro}
               columns={column}
               options={options} />
         </div>
      );
   }

   if (data !== undefined &&
      data !== null &&
      data.ticketsFiltro !== undefined &&
      data.ticketsFiltro !== null) {
      return verListaTicket();
   } else {
      return <div>No existe Tickets registrados</div>;
   }
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ListaTicket);